module.exports = __webpack_public_path__ + "img/learn-2-on.8d8190b0.png";